import TemplatesPage from "@/pages/templates";
import type { RouteConfig } from "../models/types";

export const templateRoutes: RouteConfig[] = [
	{
		path: "/templates",
		element: <TemplatesPage />,
	},
	{
		path: "/templates/:AssetIdParam",
		element: <TemplatesPage />,
	},
];
